import { ethers } from "ethers";
import { GetAccount } from "./account";
import { nftContractABI, erc20abi } from "../abis/abis";
import { nftPresaleContractAddress, usdtContractAddress} from "../contracts";

    const provider2 = new ethers.providers.Web3Provider(window.ethereum);
    const provider = new ethers.providers.JsonRpcProvider("https://bsc-dataseed1.binance.org");


const nftAddtress = new ethers.Contract(nftPresaleContractAddress, nftContractABI, provider);
const usdtAddress = new ethers.Contract(usdtContractAddress, erc20abi, provider);


export const getTotalSold  = async () => {
    try{
 const totalSold =  await nftAddtress.getAllMint();
 console.log("total Sold", totalSold.toNumber());
 return totalSold.toNumber();
} catch (error) {
    console.log(error)
}
} 

export const getMyMintedAmount = async () => {
    try {
    const account = GetAccount();
    const myMintedAmount = await nftAddtress.userMinted(account);
    return myMintedAmount.toNumber();
    } catch (error) {
        console.log(error)
    }
}

export const getAllowance = async () => {
    try {
    const account = GetAccount();
    const allowance = await usdtAddress.allowance(account, nftPresaleContractAddress);
    console.log("allowance", allowance.toNumber())
    return allowance.toNumber();
    } catch (error) {
        console.log(error)
    }
}

